import React from 'react';
import {useSelector} from "react-redux";
import {format, parseISO} from "date-fns";
import {warrantyList, warrantyListLoading} from "./warrantySearchSlice";
import {Spinner} from "@deere/ux.uxframe-react";
import {TextFilter, WtyReportTable} from "../common/wty-report-table/WtyReportTable";
import {languageResponseData} from "../Translation/translationSerachSlice";

const WarrantyList = () => {

    const translationsResponse = useSelector(languageResponseData);
    const translate = (key, defaultText) => {
    return translationsResponse[key] || defaultText;
    };;

    const warranties = useSelector(warrantyList);
    const warrantiesLoading = useSelector(warrantyListLoading);

    const warrantyColumns = [
        {
            Header: translate('warranty_type', 'Warranty Type'),
            accessor: 'warrantyTypeName',
            Filter: TextFilter
        },
        {
            Header: translate('coverage_term', 'Coverage Term'),
            accessor: 'coverageTerm',
            Filter: TextFilter
        },
        {
            Header: translate('expiration_date', 'Expiration Date'),
            accessor: 'expirationDate',
            Filter: TextFilter
        },
        {
            Header: translate('days_remaining', 'Days Remaining(may be estimate)'),
            accessor: 'daysRemaining',
            Filter: TextFilter
        },
        {
            Header: translate('hours_limit', 'Hours Limit'),
            accessor: 'hoursLimit',
            Filter: TextFilter
        },
        {
            Header: translate('deductible_amt', 'Deductible Amount'),
            accessor: 'deductibleCost',
            Filter: TextFilter
        }
    ];

    let warrantiesData = [];

    if (warranties && Array.isArray(warranties) && warranties.length > 0) {
        warrantiesData = warranties.map((warranty, index) => {
            return (
                {
                    warrantyTypeName: warranty.warrantyTypeName,
                    coverageTerm: warranty.coverageTerm,
                    expirationDate: format(new Date(parseISO(warranty.expirationDate)), 'dd MMM yyyy'),
                    daysRemaining: warranty.daysRemaining,
                    hoursLimit: warranty.hoursLimit,
                    deductibleCost: warranty.deductibleCost
                }
            );
        })
    }
    return (
        <>
            {
                warrantiesLoading ? (
                    <div className="uxf-spinner-border-inline mt-4">
                        <Spinner className="uxf-spinner-border-sm" animation="border"
                                 accessibilityLabel="Loading warranties"/>
                        <p aria-hidden="true" className="uxf-spinner-border-inline-text">
                            Loading warranties...
                        </p>
                    </div>
                ) : (
                    <div>
                        {
                            warranties && Array.isArray(warranties) && warranties.length > 0 ? (
                                <WtyReportTable columns={warrantyColumns} data={warrantiesData}/>
                            ) : (
                                <span>{translate('',' No Warranty Coverage information found for the product.')}
                                   </span>
                            )
                        }
                    </div>
                )
            }
        </>
    );
};

export default WarrantyList;
